import { Component } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  protected _commonService: CommonService;
  constructor(commonService: CommonService) {
    this._commonService = commonService;
  }
}
